<template>
  <section 
    class="n-section-primary tw-flex tw-flex-col tw-items-center tw-justify-center tw-overflow-hidden"
    v-if="variants.v1 === variant"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="left_bottom"
      :company-key="company.company_key"
    />
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="right_top"
      :company-key="company.company_key"
    />
    <div class="tw-z-10 tw-mb-12 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-text-center">
      <h6>{{ vars.altTitleText }}</h6>
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div v-if="vars.videoUrl" class="tw-relative tw-z-10 tw-w-full tw-max-w-[900px] tw-overflow-hidden">
      <library-iframe :src="vars.videoUrl" class="tw-h-full tw-w-full" :h-ratio="9" :w-ratio="16" />
    </div>
    <div class="tw-z-10 tw-mt-4 tw-max-w-[600px] tw-text-center md:tw-mt-8">
      <p>{{ vars.descriptionText }}</p>
      <div class="tw-mt-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 md:tw-flex-row md:tw-gap-6">
        <nuxt-link v-for="button in buttons" :to="button.link" :class="`n-${button.type} n-btn tw-w-full md:tw-w-auto`"
          ><div class="n-btn-container tw-w-full md:tw-w-auto">
            <div class="n-btn-group">
              <div class="n-btn-t1">{{ button.label }}</div>
              <div class="n-btn-t2">{{ button.label }}</div>
            </div>
          </div></nuxt-link
        >
      </div>
    </div>
  </section>

   <section 
    class="n-section-primary tw-flex tw-flex-col tw-items-center tw-justify-center tw-overflow-hidden"
    v-if="variants.v2 === variant"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="right_bottom"
      :company-key="company.company_key"
    />
    <BlockSymbol
      v-if="vars.watermarkImage"
      block-logo-image="https://files.pendlehillproperties.neuronwebsites.co.uk/pendlelefttop-kdeb77z57.png"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="left_top"
      :company-key="company.company_key"
    />
    <div class="tw-z-10 tw-mb-12 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-text-center">
      <h6>{{ vars.altTitleText }}</h6>
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div v-if="vars.videoUrl" class="tw-relative tw-z-10 tw-w-full tw-max-w-[900px] tw-overflow-hidden">
      <library-iframe :src="vars.videoUrl" class="tw-h-full tw-w-full" :h-ratio="9" :w-ratio="16" />
    </div>
    <div class="tw-z-10 tw-mt-4 tw-max-w-[600px] tw-text-center md:tw-mt-8">
      <p>{{ vars.descriptionText }}</p>
      <div class="tw-mt-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 md:tw-flex-row md:tw-gap-6">
        <nuxt-link v-for="button in buttons" :to="button.link" :class="`n-${button.type} n-btn tw-w-full md:tw-w-auto`"
          ><div class="n-btn-container tw-w-full md:tw-w-auto">
            <div class="n-btn-group">
              <div class="n-btn-t1">{{ button.label }}</div>
              <div class="n-btn-t2">{{ button.label }}</div>
            </div>
          </div></nuxt-link
        >
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'RegisterBox',

  components: {
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  data() {
    return { form: null, variants: { v1: 'v1', v2: 'v2' } };
  },
  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
